/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import moment from 'moment'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { Card, CircularProgress, Subheader, RaisedButton  } from 'material-ui'
import { TextField } from 'generic/form'

import * as constants from 'constants/Beneficiary'

import * as identityActions from 'actions/Identity'
import * as actions from 'actions/Beneficiary'

class Form extends React.Component {
  constructor (props) {
    super(props)

    autoBind(this)

    this.state = {
      loading: false,
      beneficiary: undefined,
      identity: undefined,
      errors: {}
    }
  }

  componentDidMount() {
    this.setState({
      loading: true
    })

    const beneficiaryUid = this.props.prestation.beneficiary_numbers.length &&
                           this.props.prestation.beneficiary_numbers[0].beneficiary
                            ? this.props.prestation.beneficiary_numbers[0].beneficiary.uid
                            : undefined

    let beneficiary = this.props.prestation.beneficiary_numbers.length &&
                      this.props.prestation.beneficiary_numbers[0].beneficiary
                        ? this.props.prestation.beneficiary_numbers[0].beneficiary
                        : undefined
    let identity = beneficiary ? beneficiary.identities[0] : undefined

    return actions.getBeneficiary(beneficiaryUid)
      .then((result) => {
        beneficiary = {
          ...result,
          ...beneficiary,
        }

        this.setState({
          beneficiary: beneficiary
        })

        const identityUid = result.identities.length ? result.identities[0].uid : undefined

        return identityActions.getIdentity(identityUid)
      })
      .then((result) => {
        this.setState({
          identity: {
            ...result,
            ...identity,
            phone_numbers: identity && identity.phone_numbers ? [identity.phone_numbers] : [],
            emails: identity && identity.emails ? [identity.emails] : [],
          },
          loading: false
        })
      })
  }

  getFieldErrorObject (errors) {
    let errorObject = {}
    errors.forEach((error) => {
      errorObject[error.field_name] = error.errors[0].user_message
    })

    return errorObject
  }

  handleChange(name, value) {
    this.setState({
      [name]: value
    })
  }

  handleIdentityChange(event, value) {
    const identity = {
      ...this.state.identity,
      [event.target.name]: value
    }

    this.handleChange('identity', identity)
  }

  handleContactInformationChange(event, value) {
    const identity = {
      ...this.state.identity,
      [event.target.name]: [value]
    }

    this.handleChange('identity', identity)
  }

  handleIdentityBirthDateChange (event, value) {
    let date = value === '' ? undefined : value

    if (date && date.length === 10) {
      const formattedDate = moment(value, 'DD.MM.YYYY')

      if (moment(formattedDate, 'YYYY-MM-DD').isValid()) {
        date = moment(formattedDate).format('YYYY-MM-DD')

        this.setState({
          errors: {
            ...this.state.errors,
            birth_date: undefined
          }
        })

      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            birth_date: this.props.intl.formatMessage(constants.messages.DATE_INVALID)
          }
        })
      }
    }

    this.handleIdentityChange(event, date)
  }

  handleCancel() {
    this.props.handleFormChange('beneficiaryFormVisible', false)
  }

  handleSave() {
    this.setState({
      loading: true
    })

    const isBirthDateMandatory = this.props.prestation.paying_customer && this.props.prestation.paying_customer.mandatory_fields.includes('beneficiary.birth_date')

    if (!this.state.identity.first_name ||
        !this.state.identity.last_name ||
        (!this.state.identity.birth_date && isBirthDateMandatory)) {
      this.setState({
        loading: false,
        errors: {
          first_name: !this.state.identity.first_name
            ? this.props.intl.formatMessage(constants.messages.MANDATORY_FIELD)
            : undefined,
          last_name: !this.state.identity.last_name
            ? this.props.intl.formatMessage(constants.messages.MANDATORY_FIELD)
            : undefined,
          birth_date: !this.state.identity.birth_date && isBirthDateMandatory
            ? this.props.intl.formatMessage(constants.messages.MANDATORY_FIELD)
            : undefined,
        }
      })

      return
    }

    const identity = {
      ...this.state.identity,
      phone_numbers: this.state.identity.phone_numbers.join(),
      emails: this.state.identity.emails.join(),
    }

    identityActions.postIdentity(identity)
      .then((identity) => {
        const beneficiary = {
          ...this.state.beneficiary,
          identities: [identity],
        }

        return actions.postBeneficiary(beneficiary)
      })
      .then((beneficiary) => {
        const beneficiaryNumber = {
          ...this.props.prestation.beneficiary_numbers[0],
          beneficiary: beneficiary
        }

        this.props.handlePrestationChange('beneficiary_numbers', [beneficiaryNumber])
        this.setState({
          loading: false
        })
        this.props.handleFormChange('beneficiaryFormVisible', false)
      })
      .catch((errors) => {
        let fieldErrors = {}
        if (errors.response && errors.response.status === 400) {
          fieldErrors = this.getFieldErrorObject(errors.response.data.field_errors)
        }

        this.setState({
          loading: false,
          errors: fieldErrors
        })
      })
  }

  render () {
    const identityMeta = this.state.identity ? this.state.identity.meta.fields : {}
    const isBirthDateMandatory = this.props.prestation.paying_customer && this.props.prestation.paying_customer.mandatory_fields.includes('beneficiary.birth_date')

    const birthDate = this.state.identity &&
                      this.state.identity.birth_date &&
                      this.state.identity.birth_date.length === 10
                        ? moment(this.state.identity.birth_date).format('DD.MM.YYYY')
                        : this.state.identity && this.state.identity.birth_date
                          ? this.state.identity.birth_date
                          : undefined

    return (
      <Card
        style={{
          paddingLeft: 5,
          paddingRight: 5,
          paddingBottom: 10,
          height: '100%',
          ...this.props.style
        }}
      >
        {
          this.state.loading ||
          !this.state.beneficiary ||
          !this.state.identity
            ? <CircularProgress
              size={200}
              style={{
                width: '100%',
                height: 300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
            : <React.Fragment>
              <Subheader
                style={styles.subHeader}
              >
                {this.props.intl.formatMessage(constants.messages.CREATE_BENEFICIARY)}
              </Subheader>
              <div
                style={!this.props.style ? {minHeight: 470} : {minHeight: 250}}
              >
                <div className='row'>
                  <div className='col-md-6 col-xs-12'>
                    <TextField
                      meta={identityMeta.first_name}
                      name='first_name'
                      value={this.state.identity.first_name}
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.FIRST_NAME_LABEL)}
                      onChange={this.handleIdentityChange}
                      errorText={this.state.errors.first_name}
                      placeholderMandatory={true}
                    />
                  </div>

                  <div className='col-md-6 col-xs-12'>
                    <TextField
                      meta={identityMeta.last_name}
                      name='last_name'
                      value={this.state.identity.last_name}
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.LAST_NAME_LABEL)}
                      onChange={this.handleIdentityChange}
                      errorText={this.state.errors.last_name}
                      placeholderMandatory={true}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-6 col-xs-12'>
                    <TextField
                      meta={{'mandatory': isBirthDateMandatory}}
                      name='birth_date'
                      value={birthDate}
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.BIRTH_DATE_LABEL)}
                      onChange={this.handleIdentityBirthDateChange}
                      mask='99.99.9999'
                      errorText={this.state.errors.birth_date}
                      placeholderMandatory={isBirthDateMandatory}
                      placeholder={
                        this.state.errors.birth_date ||
                        !isBirthDateMandatory
                          ? this.props.intl.formatMessage(constants.messages.BENEFICIARY_RECOMMANDED)
                          : undefined
                      }
                    />
                  </div>

                  <div className='col-md-6 col-xs-12'>
                    <TextField
                      meta={identityMeta.phone_numbers}
                      name='phone_numbers'
                      value={
                        this.state.identity.phone_numbers &&
                        this.state.identity.phone_numbers.length > 0
                          ? this.state.identity.phone_numbers[0]
                          : undefined
                      }
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.PHONE_NUMBER_LABEL)}
                      onChange={this.handleContactInformationChange}
                      errorText={this.state.errors.phone_numbers}
                    />
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-6 col-xs-12'>
                    <TextField
                      meta={identityMeta.emails}
                      name='emails'
                      value={
                        this.state.identity.emails &&
                        this.state.identity.emails.length > 0
                          ? this.state.identity.emails[0]
                          : undefined
                      }
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.EMAIL_LABEL)}
                      onChange={this.handleContactInformationChange}
                      errorText={this.state.errors.emails}
                    />
                  </div>

                  <div className='col-md-6 col-xs-12'>
                    <TextField
                      meta={identityMeta.remarks}
                      name='remarks'
                      value={this.state.identity.remarks}
                      multiLine={true}
                      floatingLabelText={this.props.intl.formatMessage(constants.messages.REMARK_LABEL)}
                      onChange={this.handleIdentityChange}
                      errorText={this.state.errors.remarks}
                    />
                  </div>
                </div>
              </div>

              <div
                className='row'
              >
                <div className='col-xs-offset-1 col-xs-5'
                >
                  <RaisedButton
                    style={styles.button}
                    label={this.props.intl.formatMessage(constants.messages.BENEFICIARY_ACTION_CANCEL )}
                    onClick={this.handleCancel}
                  />
                </div>

                <div className='col-xs-5'>
                  <RaisedButton
                    primary={true}
                    style={styles.button}
                    label={this.props.intl.formatMessage(constants.messages.CREATE_BENEFICIARY_LABEL)}
                    onClick={this.handleSave}
                  />
                </div>
              </div>
            </React.Fragment>
        }
      </Card>
    )
  }
}

const styles = {
  card: {
    marginTop: 5,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 5,
    height: 600
  },
  subHeader: {
    textAlign: 'center'
  },
  button: {
    width: '100%',
    minWidth: '40%'
  },
}

export default injectIntl(Form)



// WEBPACK FOOTER //
// ./src/components/common/beneficiary/Form.js